import { createFileRoute } from '@tanstack/react-router';
import { MySystemsListPage } from '@/pages/systems/MySystemsListPage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/systems/')({
  component: MySystemsListPage,
  beforeLoad: createCaslGuard('MySystems'),
  validateSearch: dataTableSearchSchema({})
});
